import React from "react";
import styles from "./responsive.module.scss";

// A single record rendered as a card - the mobile-friendly stand-in for a
// table row. `fields` is a list of { label, value } shown as a stacked
// label/value list, so any table column maps onto it directly.
const DataCard = ({ title, subtitle, badge, fields = [], actions, onClick, accent }) => {
    const clickable = typeof onClick === "function";

    return (
        <div
            className={`${styles.card} ${clickable ? styles.cardClickable : ""} ${accent ? styles[`accent${accent}`] : ""}`}
            onClick={onClick}
            onKeyDown={clickable ? (e) => (e.key === "Enter" || e.key === " ") && onClick(e) : undefined}
            role={clickable ? "button" : undefined}
            tabIndex={clickable ? 0 : undefined}
        >
            {(title || badge || subtitle) && (
                <div className={styles.cardHeader}>
                    <div className={styles.cardHeading}>
                        {title && <div className={styles.cardTitle}>{title}</div>}
                        {subtitle && <div className={styles.cardSubtitle}>{subtitle}</div>}
                    </div>
                    {badge && <div className={styles.cardBadge}>{badge}</div>}
                </div>
            )}

            {fields.filter(Boolean).length > 0 && (
                <div className={styles.cardFields}>
                    {fields.filter(Boolean).map((f, i) => (
                        <div className={styles.cardField} key={f.label || i}>
                            <span className={styles.cardFieldLabel}>{f.label}</span>
                            <span className={styles.cardFieldValue}>{f.value === undefined || f.value === null || f.value === "" ? "-" : f.value}</span>
                        </div>
                    ))}
                </div>
            )}

            {actions && (
                <div className={styles.cardActions} onClick={(e) => e.stopPropagation()}>
                    {actions}
                </div>
            )}
        </div>
    );
};

export default DataCard;
